import { get, post } from './api_base';

export const getUserAgents = async (owner_user) => {
  const path = `user-reagents/${owner_user}`;

  try {
    const getRequest = await get(path);
    return getRequest;
  } catch(err) {
    console.log('Error getting /user-agents: ', err);
    return err;
  }
}

export const saveUserAgents = async (fieldValues) => {
  const path = 'user-reagents';
  const body = fieldValues;

  try {
    const postRequest = await post(path, body);
    return postRequest;
  } catch(err) {
    console.log('Error posting to /user-reagents: ', err);
    return err;
  }
};

export const removeUserAgent = async (agent_owner_user, agent_remove) => {
  const path = 'user-reagents/remove';
  const body = { agent_owner_user, agent_remove };

  try {
    const postRequest = await post(path, body);
    return postRequest;
  } catch(err) {
    console.log('Error posting to /user-reagents/remove: ', err);
    return err;
  }
}
